<div class="page">
  <div class="page-inner" *ngIf="pageErrorMessage">
    <div class="page-main">
      <div class="page-content">
        <div class="page-error">
          <div class="page-error-message" [innerHTML]="pageErrorMessage"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-inner" *ngIf="dataLoaded">
    <div class="page-header" *ngIf="showHeader">
      <app-header></app-header>
    </div>
    <div class="page-main">
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
      <div class="page-modal" [ngClass]="{ shown: showModal }">
        <button type="button" class="btn-default btn-modal-close" (click)="closeModal()" *ngIf="showModalClose">
          <span class="icon">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m11.293 3.2929c0.3905-0.39052 1.0237-0.39052 1.4142 0 0.3905 0.39053 0.3905 1.0237 0 1.4142l-3.2929 3.2929 3.2929 3.2929c0.3905 0.3905 0.3905 1.0237 0 1.4142s-1.0237 0.3905-1.4142 0l-3.2929-3.2929-3.2929 3.2929c-0.39053 0.3905-1.0237 0.3905-1.4142 0-0.39052-0.3905-0.39052-1.0237 0-1.4142l3.2929-3.2929-3.2929-3.2929c-0.39052-0.39053-0.39052-1.0237 0-1.4142 0.39053-0.39052 1.0237-0.39052 1.4142 0l3.2929 3.2929 3.2929-3.2929z" fill-rule="evenodd"/></svg>
          </span>
        </button>
        <div class="modal-content">
          <div [ngSwitch]="routeUrl" *ngIf="routeUrl.indexOf('/map/artist/') === -1">
            <app-info *ngSwitchCase="'/map/info'">Show Info</app-info>
            <artists-list *ngSwitchCase="'/map/artists'">Show Artists</artists-list>
            <app-directions *ngSwitchCase="'/map/directions'"></app-directions>
            <app-howto *ngSwitchCase="'/map/how-to-interact'"></app-howto>
            <div *ngSwitchDefault>Default</div>
          </div>
          <artists-single *ngIf="projectId" [projectId]="projectId"></artists-single>
        </div>
      </div>
    </div>
    <div class="page-footer" *ngIf="showFooter">
      <app-footer></app-footer>
    </div>
  </div>
</div>
